import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inactiva',
  templateUrl: './inactiva.component.html',
  styleUrls: ['./inactiva.component.css']
})
export class InactivaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
